import { useEffect, useState } from "react";
import { IMAGES } from "../../../../assets";
import { useInView } from "react-intersection-observer";

const AppStore = () => {
  const [ref, inView] = useInView({
    triggerOnce: true, // Trigger animation only once
    threshold: 0.3, // Trigger when 10% of the image is visible
  });
  return (
    <section className="offer-section">
      <div className="container">
        <figure className="mb-0 offer-sidelayer">
          <img src={IMAGES.offer_sidelayer} alt="" />
        </figure>
        <div ref={ref} className={`row ${inView ? "animate__animated animate__slideInDown" : ""}`}>
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="offer_content" data-aos="fade-down">
              <h4 className="text-white">Your cosmic guide is just a tap away</h4>
              <h2 className="text-white">Download Our Mobile App Now!</h2>
              <p className="text-white">
                Download the Cosmic Advice app to access certified astrologers, real-time consultations, daily horoscopes, and personalized guidance— all from the palm of your hand. Anytime, anywhere, the universe is with you.
              </p>
              <div className="offer-imagewrapper">
                <a
                  className="image_apple"
                  href="https://www.apple.com/app-store/"
                >
                  <figure className="mb-0 offer-apple">
                    <img
                      className="img-fluid"
                      src={IMAGES.bannerapple_img1}
                      alt=""
                    />
                  </figure>
                </a>
                <a
                  className="image_google" target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.cosmicadvice"
                >
                  <figure className="mb-0 offer-google">
                    <img
                      className="img-fluid"
                      src={IMAGES.bannergoogle_img2}
                      alt=""
                    />
                  </figure>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppStore;
